import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BreadcrumbService } from '../../../shared/components/breadcrumbs/breadcrumbs';
import { AppscriptsNumber, AppscriptsNumbersFilter, AppscriptsUpdateNumber } from '../../../shared/models/appscripts-user.model';
import { AppscriptsUserService } from '../../../shared/services/appscripts-user.service';
import { BatchTasks } from '../../../shared/services/batch-tasks';
import { BrowserUtils } from '../../../shared/services/browser-utils';
import { ModalService } from '../../../shared/services/modal.service';
import { NetInfoService } from '../../../shared/services/net-info.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { AppscriptsUserFilterComponent } from '../appscripts-user-filter/appscripts-user-filter.component';
import { AppscriptsUserTableComponent } from '../appscripts-user-table/appscripts-user-table.component';

@Component({
  standalone: false,
  selector: 'app-appscripts-user-index',
  templateUrl: 'appscripts-user-index.component.html',
  styleUrls: ['appscripts-user-index.component.scss'],
})
export class AppscriptsUserIndexComponent implements AfterViewInit {
  @ViewChild(AppscriptsUserTableComponent, { static: false }) table: AppscriptsUserTableComponent;
  @ViewChild(AppscriptsUserFilterComponent, { static: false }) filter: AppscriptsUserFilterComponent;

  copyPhonesTextControlRows: number;
  model: AppscriptsNumbersFilter = { moUserEnables: false };

  selectedRows: AppscriptsNumber[] = [];
  batchCompleted = 0;
  progressShow = false;

  constructor(
    public breadcrumbs: BreadcrumbService,
    public router: Router,
    public modemService: AppscriptsUserService,
    public notificationService: NotificationService,
    public netInfoService: NetInfoService,
    titleService: Title,
    public modal: ModalService,
    public route: ActivatedRoute
  ) {
    titleService.setTitle('Appscripts numbers');
    this.route.queryParams.subscribe(p => {
      for (const i in p) {
        this.model[i] = p[i];
      }
    });
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      if (params.phonenumber) {
        this.filter.changeFilterValueByName(params.phonenumber, 'Phone', false);
        this.filter.onSubmitClick();
      }
    });

    if (this.filter.filterStateRestored) {
      this.filter.onSubmitClick();
    }
  }

  onFilter(data) {
    const params: AppscriptsNumbersFilter = { moUserEnables: data.moUserEnables ? true : false };
    const queryParams = {};

    for (const i in data) {
      if (data[i] !== null) {
        queryParams[i] = data[i];
      }
    }

    if (data.mtStatuses?.length) {
      params.mtStatuses = data.mtStatuses;
    }
    if (data.moStatuses?.length) {
      params.moStatuses = data.moStatuses;
    }
    if (data.cliStatuses?.length) {
      params.cliStatuses = data.cliStatuses;
    }

    if (data.activeFrom && data.activeTo) {
      params.activeFrom = data.activeFrom;
      params.activeTo = data.activeTo;
    }
    const isInt = v => {
      return !(v === '' || v === null || v === undefined);
    };

    if (isInt(data.mtSmsCountMin) && isInt(data.mtSmsCountMax)) {
      params.mtSmsCountMin = data.mtSmsCountMin;
      params.mtSmsCountMax = data.mtSmsCountMax;
    } else if (isInt(data.mtSmsCountMin)) {
      params.mtSmsCountMin = data.mtSmsCountMin;
    } else if (isInt(data.mtSmsCountMax)) {
      params.mtSmsCountMax = data.mtSmsCountMax;
    }

    if (isInt(data.moSmsCountMin) && isInt(data.moSmsCountMax)) {
      params.moSmsCountMin = data.moSmsCountMin;
      params.moSmsCountMax = data.moSmsCountMax;
    } else if (isInt(data.moSmsCountMin)) {
      params.moSmsCountMin = data.moSmsCountMin;
    } else if (isInt(data.moSmsCountMax)) {
      params.moSmsCountMax = data.moSmsCountMax;
    }

    if (isInt(data.balanceMin) && isInt(data.balanceMax)) {
      params.balanceMin = Math.trunc(data.balanceMin * 100);
      params.balanceMax = Math.trunc(data.balanceMax * 100);
    } else if (isInt(data.balanceMin)) {
      params.balanceMin = Math.trunc(data.balanceMin * 100);
    } else if (isInt(data.balanceMax)) {
      params.balanceMax = Math.trunc(data.balanceMax * 100);
    }
    if (data.networks && data.networks.length > 0) {
      params.mcc = data.networks.map(n => n.mcc).filter(m => m !== '');
      params.mnc = data.networks.map(n => n.mnc).filter(m => m !== '');
    }
    if (data.phoneNumbers) {
      params.phoneNumbers = data.phoneNumbers
        .split(' ')
        .map(p => p.trim())
        .filter(p => p !== '');
    }
    if (data.mcc && data.mcc.length > 0) {
      params.mcc = data.mcc
        ?.split(' ')
        .map(m => m.trim())
        .filter(m => m !== '');
    }
    if (data.mnc && data.mnc.length > 0) {
      params.mnc = data.mnc
        ?.split(' ')
        .map(m => m.trim())
        .filter(m => m !== '');
    }
    if (data.originalMnc && data.originalMnc.length > 0) {
      params.originalMnc = data.originalMnc
        ?.split(' ')
        .map(m => m.trim())
        .filter(m => m !== '');
    }
    if (data.id) {
      params.id = data.id
        .split(' ')
        .map(id => id.trim())
        .filter(id => id !== '');
    }
    const rawSearchFields = ['referralCode', 'referrerCode', 'paymentAddress', 'email', 'userId'];
    rawSearchFields.map(field => {
      const v = data[field];
      if (v === '' || v === null) {
        return;
      }
      params[field] = v;
    });

    const apply = () => {
      this.table.filter = params;
      this.table.currentPageNumber = 1;
      this.table.update();
    };

    if (!this.table) {
      const interval = setInterval(() => {
        if (this.table) {
          apply();
        }
        clearInterval(interval);
      }, 100);
    } else {
      apply();
    }
  }

  private getUpdateNumber(row: AppscriptsNumber): AppscriptsUpdateNumber {
    return {
      phoneNumber: row.phoneNumber,
      mcc: row.mcc,
      mnc: row.mnc,
      // country: row.country,
      // provider: row.provider,
      // originalProvider: row.originalProvider,
      originalMnc: row.originalMnc,
      blocked: row.blocked,
      updateHlr: row.updateHlr,
    };
  }

  onBatchMoShow() {
    this.modal
      .confirm()
      .open()
      .result.then(res => {
        if (!res) {
          return;
        }
        this.batchMoShow();
      });
  }

  private batchMoShow() {
    const tasks = this.selectedRows.map(row => {
      const data = this.getUpdateNumber(row);
      // data.showNumberMo = true;
      return this.modemService.updateNumber(row.id, data).pipe(
        map(() => {
          this.notificationService.success('Show numbers', 'Appscripts');
          this.completeTask();
        }),
        catchError((err, caught) => {
          this.notificationService.error('Show number an error', 'Appscripts');
          this.completeTask();
          return caught;
        })
      );
    });
    this.startTasks(tasks);
  }

  onBatchMoHide() {
    this.modal
      .confirm()
      .open()
      .result.then(res => {
        if (!res) {
          return;
        }
        this.batchMoHide();
      });
  }

  private batchMoHide() {
    const tasks = this.selectedRows.map(row => {
      const data = this.getUpdateNumber(row);
      // data.showNumberMo = false;
      return this.modemService.updateNumber(row.id, data).pipe(
        map(() => {
          this.notificationService.success('Hide numbers', 'Appscripts');
          this.completeTask();
        }),
        catchError((err, caught) => {
          this.notificationService.error('Hide number an error', 'Appscripts');
          this.completeTask();
          return caught;
        })
      );
    });
    this.startTasks(tasks);
  }

  onBatchShow() {
    this.modal
      .confirm()
      .open()
      .result.then(res => {
        if (!res) {
          return;
        }
        this.batchShow();
      });
  }

  private batchShow() {
    const tasks = this.selectedRows.map(row => {
      const data = this.getUpdateNumber(row);
      // data.showNumberMt = true;
      return this.modemService.updateNumber(row.id, data).pipe(
        map(() => {
          this.notificationService.success('Show numbers', 'Appscripts');
          this.completeTask();
        }),
        catchError((err, caught) => {
          this.notificationService.error('Show number an error', 'Appscripts');
          this.completeTask();
          return caught;
        })
      );
    });
    this.startTasks(tasks);
  }

  onBatchHide() {
    this.modal
      .confirm()
      .open()
      .result.then(res => {
        if (!res) {
          return;
        }
        this.batchHide();
      });
  }

  private batchHide() {
    const tasks = this.selectedRows.map(row => {
      const data = this.getUpdateNumber(row);
      // data.showNumberMt = false;
      return this.modemService.updateNumber(row.id, data).pipe(
        map(() => {
          this.notificationService.success('Hide numbers', 'Appscripts');
          this.completeTask();
        }),
        catchError((err, caught) => {
          this.notificationService.error('Hide number an error', 'Appscripts');
          this.completeTask();
          return caught;
        })
      );
    });
    this.startTasks(tasks);
  }

  onBatchDelete() {
    this.modal
      .confirm()
      .open()
      .result.then(res => {
        if (!res) {
          return;
        }
        this.batchDelete();
      });
  }

  private batchDelete() {
    const tasks = this.selectedRows.map(row => {
      return this.modemService.deleteUser(row.userId).pipe(
        map(() => {
          this.notificationService.success('User deleted', 'Appscripts');
          this.completeTask();
        }),
        catchError((err, caught) => {
          this.notificationService.error('User delete an error', 'Appscripts');
          this.completeTask();
          return caught;
        })
      );
    });
    this.startTasks(tasks);
  }

  onClickCopyPhones() {
    const text = this.selectedRows.map(_ => _.phoneNumber).join('\n');
    BrowserUtils.copyToClipboard(text);
    this.notificationService.success('Copy to clipboard', 'Appscripts');
  }

  onClickCopyPhonesControl(e) {
    const input = e.target;
    if (input.setSelectionRange) {
      input.setSelectionRange(0, input.value.length);
    } else {
      input.select();
    }
  }

  startTasks(tasks: Observable<any>[]) {
    this.progressShow = true;
    this.batchCompleted = 0;
    this.table.loading = true;
    new BatchTasks(tasks).run(4);
  }

  completeTask() {
    this.batchCompleted++;
    if (this.selectedRows.length === this.batchCompleted) {
      this.table.loading = false;
      this.progressShow = false;
      this.selectedRows = [];
      this.table.update();
    }
  }

  batchClear() {
    this.progressShow = false;
    this.selectedRows = [];
    this.table.resetBatch();
  }
}
